module.exports = __webpack_public_path__ + "img/vizual-PR-Days_en.0a9268f5.jpg";